/**
 * PermissionService
 * @module client/src/app/shared/services
 */
import { Injectable } from '@angular/core';

import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { PortalHttpClient } from '@services/http-client';

/**
 * # PermissionService
 * Defines the service for checking user permissions
 */
@Injectable()
export class PermissionService {
    public permissionURL = '/me/permissions';

    constructor(private http: PortalHttpClient) {}

    public fetchUserPermissions(): Observable<any> {
        return this.http.get(this.permissionURL).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((error) => observableThrowError(error.errors)),
        );
    }
}
